export const SET_USER_PENDING = 'SET_USER_PENDING';
export const SET_USER = 'SET_USER';

// Action types for the extension
export const SET_ANON_USER = 'SET_ANON_USER';
export const UPDATE_EXT_SETTINGS = 'UPDATE_EXT_SETTINGS';
